import React from "react";
import "./styles/TrackRecordClientContent.scss";
import { useTranslation } from "react-i18next";
const TrackRecordClientContent = () => {
  const { t } = useTranslation();
  const clientArray = [
    "/imgs/client_01.png",
    "/imgs/client_02.png",
    "/imgs/client_03.png",
    "/imgs/client_04.png",
    "/imgs/client_05.png",
    "/imgs/client_06.png",
    "/imgs/client_07.png",
    "/imgs/client_08.png",
    "/imgs/client_09.png",
    "/imgs/client_10.png",
    "/imgs/client_11.png",
    "/imgs/client_12.png",
    "/imgs/client_13.png",
    "/imgs/client_14.png",
    "/imgs/client_15.png",
    "/imgs/client_16.png",
    "/imgs/client_17.png",
    "/imgs/client_18.png",
    "/imgs/client_19.png",
    "/imgs/client_20.png",
    "/imgs/client_21.png",
    "/imgs/client_22.png",
    "/imgs/client_23.png",
    "/imgs/client_24.png",
    "/imgs/client_25.png",
    "/imgs/client_26.png",
    "/imgs/client_27.png",
    "/imgs/client_28.png",
    "/imgs/client_29.png",
    "/imgs/client_30.png",
    "/imgs/client_31.png",
    "/imgs/client_32.png",
    "/imgs/client_33.png",
    "/imgs/client_34.png",
    "/imgs/client_35.png",
    "/imgs/client_36.png",
  ];
  const companyList = t("trackRecord.client.company.list", { returnObjects: true }) as string[];

  const schoolList = t("trackRecord.client.school.list", { returnObjects: true }) as string[];
  return (
    <>
      <div id="trackRecord_client_content">
        <div className="left">
          {clientArray.map((path: string, index) => {
            return (
              <div className="img_box" key={index}>
                <img src={path} alt="client" />
              </div>
            );
          })}
        </div>
        <div className="right">
          <div className="list_wrap company_wrap">
            <div className="title">{t("trackRecord.client.company.title")}</div>
            <ul>
              {companyList.map((text: string, index: number) => {
                return (
                  <li className="list" key={`${text}_${index}`}>
                    {text}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="list_wrap school_wrap">
            <div className="title">{t("trackRecord.client.school.title")}</div>
            <ul>
              {schoolList.map((text: string, index: number) => {
                return (
                  <li className="list" key={`${text}_${index}`}>
                    {text}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrackRecordClientContent;
